// fatchSet.js 파일 전체 내용

// [토큰 매니저] 동시 다발적인 토큰 갱신 요청을 하나로 묶어주는 Promise Lock
let refreshPromise = null;

export const getValidToken = async (loginType) => {
    // 누군가 이미 갱신 중이면, 백엔드로 가지 않고 기다립니다.
    if (refreshPromise) {
        return refreshPromise;
    }

    refreshPromise = new Promise(async (resolve, reject) => {
        let refreshToken = localStorage.getItem("refresh_token");

        if (!refreshToken || refreshToken === "null" || refreshToken === "undefined") {
            reject("No refresh token");
            return;
        }

        try {
            // 주소 끝에 /api 가 붙지 않도록 환경변수에서 제거 후 조립
            let refreshRes = await fetch(`${process.env.REACT_APP_API_URL.replace('/api', '')}/oauth/token`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    grant_type: 'refresh_token',
                    refresh_token: refreshToken,
                    client_id: process.env.REACT_APP_PASSPORT_CLIENT_ID || '1',
                    client_secret: process.env.REACT_APP_PASSPORT_CLIENT_SECRET || '시크릿키',
                })
            });

            if (refreshRes.ok) {
                let refreshData = await refreshRes.json();

                // 새 토큰 저장
                if (loginType === "sessionLogin") {
                    sessionStorage.setItem("token", refreshData.access_token);
                } else {
                    localStorage.setItem("token", refreshData.access_token);
                    localStorage.setItem("refresh_token", refreshData.refresh_token);
                }

                resolve(refreshData.access_token); // 대기 중인 모두에게 새 토큰 전달!
            } else {
                reject("Refresh failed");
            }
        } catch (error) {
            reject(error);
        } finally {
            refreshPromise = null; // 작업이 끝났으니 대기실 비우기
        }
    });

    return refreshPromise;
};

// [API 통신 래퍼] POST, DELETE 등 버튼 클릭 시 사용하는 함수
export const FatchApi = async function (fatchData) {
    let storageToken = fatchData.loginType === "sessionLogin"
        ? sessionStorage.getItem("token")
        : localStorage.getItem("token");

    let headers = {
        'Accept': 'application/json'
    };

    // 방어 로직: 쓰레기값("null") 차단
    if ((fatchData.loginType === "login" || fatchData.loginType === "sessionLogin") &&
        storageToken && storageToken !== "null" && storageToken !== "undefined") {
        headers['Authorization'] = 'Bearer ' + storageToken;
    }

    let fetchOptions = {
        method: fatchData.type,
        headers: headers
    };

    if (fatchData.formDataItem && (fatchData.type === "POST" || fatchData.type === "DELETE" || fatchData.type === "PUT")) {
        fetchOptions.body = fatchData.formDataItem;
    }

    try {
        let response = await fetch(`${process.env.REACT_APP_API_URL}${fatchData.url}`, fetchOptions);

        // 401 만료 시: 토큰 매니저에게 새 열쇠를 부탁함
        if (response.status === 401) {
            console.log("⚠️ [FatchApi] 만료 감지! 대기실을 통해 갱신 시도...");
            try {
                let newToken = await getValidToken(fatchData.loginType);

                // 새 열쇠로 갈아끼우고 재요청!
                fetchOptions.headers['Authorization'] = 'Bearer ' + newToken;
                response = await fetch(`${process.env.REACT_APP_API_URL}${fatchData.url}`, fetchOptions);

            } catch (refreshError) {
                console.log("❌ [FatchApi] 갱신 최종 실패 -> 강제 로그아웃");
                localStorage.removeItem("token");
                localStorage.removeItem("refresh_token");

                if (window.location.pathname !== '/member/login') {
                    window.location.href = `/member/login`;
                }
                return;
            }
        }

        // 라이브 모드 에러 처리
        if (process.env.REACT_APP_TYPE === "live" && response.status !== 200) {
            window.location.href = `/pageErr/${response.status}`;
            return;
        }

        // 결과 콜백 처리
        let data = await response.json();
        if (data.success === true) {
            if (fatchData.success) fatchData.success(data);
        } else {
            if (fatchData.err) fatchData.err(data);
        }

    } catch (error) {
        console.error("FatchApi 통신 에러:", error);
    }
};

export const fatchSet = {
    FatchApi: FatchApi
};